import { DASH_LABELS, DASH_TYPES } from './dashConstants'

export const META_BY_LOCATION_DETAIL = {
  ICU: {
    label: DASH_LABELS.A_PANEL_ICU,
    partOverride: '22_58882',
    noTooltip: true,
    disableEvents: false,
    partExpected: true,
    openListView: true,
    noShowPartNumber: true,
  },
  AGAAA: {
    label: DASH_LABELS.RIGHT_HAND_B_PANEL_AG,
    partOverride: '22_58883',
    noTooltip: true,
    disableEvents: false,
    openListView: true,
    noShowPartNumber: true,
  },
}

export const DASH_META = {
  name: DASH_TYPES.DASH_M2_WING,
  panels: ['ICU', 'AGAAA'],
  width: 2050,
  height: 900,
}

export const FALLBACK_COMPONENTS_BY_DETAIL = {
  AC: 'Radio_CP001',
}

export default {
  ...DASH_META,
  ...META_BY_LOCATION_DETAIL,
  fallbacks: FALLBACK_COMPONENTS_BY_DETAIL,
  lists: {
    ICU: {
      id: 'ICU',
      label: 'A Panel: ICU',
      groups: {
        icu_switches: {
          order: 0,
          id: 'icu_switches',
          panel: 'ICU',
          label: 'Switches',
          detail: ['C'],
        },
        icu_gauges: {
          order: 1,
          icu_switches: 'icu_switches',
          panel: 'ICU',
          label: 'Gauges',
          detail: ['A'],
        },
      },
    },
    AGAAA: {
      id: 'AGAAA',
      label: 'Right Hand B Panel: AG',
      groups: {
        switches: {
          order: 0,
          id: 'switches',
          panel: 'AGAAA',
          label: 'Switches',
          detail: ['C'],
        },
        gauges: {
          order: 1,
          id: 'guages',
          panel: 'AGAAA',
          label: 'Gauges',
          detail: ['A'],
        },
        other: {
          order: 2,
          id: 'other',
          panel: 'AGAAA',
          label: 'Other',
          detail: [
            'BC',
            'J',
            'AL',
            'L',
            'F',
            'K',
            'M',
            'L',
            'AB',
            'Q',
            'WB',
            'S',
            'B',
            'AC',
            'G',
            'D',
            'R',
            'AS',
            'DD',
            'BD',
          ],
        },
      },
    },
  },
}
